import React from 'react';
import { Card, T, VibeField, MusicField, AnthemPicker } from '../fields';
import { VIBE_MAX } from '../../../utils/portalPageModel';

/*
 * VIBE + MUSIC — the vibe check, the three artists and YOUR ANTHEM · SPOTIFY, all from the shared
 * Portal field kit (`components/profile/fields`), which Onboarding v2's step 2 renders too.
 */
export default function VibeTab({ d, upd, phone }) {
  return (
    <>
      <Card phone={phone} data-testid="vibe-card">
        <span style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}><span style={T.title}>VIBE CHECK</span><span style={{ fontSize: 10, color: '#6B6B6B' }}>{d.vibe.length}/{VIBE_MAX}</span></span>
        <span style={T.help}>One sentence in your voice. Who are you at a party?</span>
        <VibeField value={d.vibe} onChange={(vibe) => upd({ vibe })} fontSize={20} />
      </Card>
      <Card phone={phone} data-testid="music-card" style={{ gap: 12 }}>
        <span style={T.title}>MUSIC THAT MOVES ME</span>
        <span style={T.help}>Three artists. The shortcut to your vibe.</span>
        <MusicField
          value={d.music}
          serif
          onChange={(i, val) => upd((s) => { const m = [...s.music]; m[i] = val; return { music: m }; })}
        />
      </Card>
      <Card phone={phone} data-testid="anthem-card" style={{ gap: 12 }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}><span style={T.title}>YOUR ANTHEM</span><span style={{ padding: '4px 10px', borderRadius: 999, background: '#1DB954', color: '#000', fontSize: 9, fontWeight: 800, letterSpacing: '.14em' }}>SPOTIFY</span></span>
        <span style={T.help}>Pick one track. It plays on your Portal page when someone visits, on their first tap.</span>
        <AnthemPicker value={d.anthem} onChange={(anthem) => upd({ anthem })} />
      </Card>
    </>
  );
}
